import { Coupon as CouponComponent } from '@elfsight/widget-ui';
import tinycolor from 'tinycolor2';

interface CouponProps {
  textColor: string;
  messages: Record<string, string>;
  coupon?: string;
  onCopied?: (value: string) => void;
}

export const Coupon = ({
  coupon,
  textColor,
  messages,
  onCopied
}: CouponProps) => {
  return (
    <CouponComponent
      color={textColor}
      borderColor={textColor}
      borderRadius={4}
      backgroundColor={tinycolor(textColor).setAlpha(0.08).toString()}
      backgroundHoverColor={tinycolor(textColor).setAlpha(0.13).toString()}
      messages={messages}
      onCopied={onCopied}
    >
      {String(coupon)}
    </CouponComponent>
  );
};
